import { getDealInsightsSupportedDateRange } from '@openx/components-deal/lib/DealInsights/utils/getDealInsightsSupportedDateRange.ts';
import { DealInsightsV2Provider } from '@openx/components-deal/lib/DealInsightsV2/context/DealInsightsV2Context.tsx';
import { DealInsightsV2 } from '@openx/components-deal/lib/DealInsightsV2/DealInsightsV2.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { DEAL_INSIGHTS_V2_ACCESS } from '@openx/constants/feature-flag-keys.ts';
import { Button } from '@openx/design-system/components/Button/Button.tsx';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { format } from 'date-fns';
import { Navigate } from 'react-router';

export const DealInsightsV2Page = () => {
  const { isGrowthbookFeatureOn } = usePermissionContext();

  if (!isGrowthbookFeatureOn(DEAL_INSIGHTS_V2_ACCESS)) {
    return <Navigate to="/deal-insights" replace />;
  }

  return (
    <DealInsightsV2Provider>
      <PageHeader
        // the new Deal Insights always uses the design-system header, independent of the future feature flag
        designSystem
        title="Deal Insights"
        // TODO(EXCH-19435): placeholder, not a real value. It is the latest date the date picker allows; replace it with the
        // real last-updated date once it has a data source.
        subtitle={`Data was last updated on ${format(getDealInsightsSupportedDateRange().maxDate, 'MMM d, yyyy')}.`}
        titlePrefix="OpenXSelect"
        sticky
        render={() => (
          // TODO(EXCH-19255): connect PDF export; the old export lives in DealInsights/components/DealInsightsPdfExport
          <Button variant="contained" color="secondary">
            Export PDF
          </Button>
        )}
      >
        <DealInsightsV2 />
      </PageHeader>
    </DealInsightsV2Provider>
  );
};
